import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "msg", "form"];

  validateEmail() {
    const email = this.inputTarget.value;
    const emailRegex = /\S+@\S+\.\S+/;

    if (!emailRegex.test(email)) {
      this.inputTarget.classList.add("border", "border-red-500");
      this.msgTarget.innerText = "Email invalide";
      this.element.querySelector("input[type='submit']").disabled = true;
    } else {
      this.inputTarget.classList.remove("border", "border-red-500");
      this.msgTarget.innerText = "";
      this.element.querySelector("input[type='submit']").disabled = false;
    }
  }

}
